import type { IModalType } from '@gp/pages/Workspace/Product/types';

// Product数据本地存储的key
export const ADD_PRODUCT_STORAGE_KEY = 'gp_add_product_cached';

// 新增Product页面三种状态的弹窗配置
export const MODAL_CFG_MAPPING: {
  [key in IModalType]: {
    title: string;
    content: string;
  };
} = {
  // 新增成功提示弹窗配置
  success: {
    title: 'Information has been submitted successfully',
    content: '',
  },
  // 是否接着本地存储的Product数据继续新增的确认弹窗配置
  continue: {
    title: 'There are unsubmitted products',
    content: 'You have unsaved changes. Leaving will discard them. Continue?',
  },
  none: {
    title: '',
    content: '',
  },
};

export const DEFAULT_INITIALPARAMS = {
  "cover": "",
  "name": "",
  "file_size": null,
  "timestamp": null,
  "project": "",
  "stage": "",
  "platform": [],
  "studio_entity_id": "",
  "priority": "",
  "group": {
    "parent": "",
    "child": ""
  },
  "form_2": "",
  "publisher": "",
  "business_model": [],
  "ip": "",
  "genre": [],
  "expanded_genre": "",
  "tag_line": "",
  "ambition": ""
};